import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'

const adminDocumentTemplateService = {
  getDocumentTemplatesForActivity: async (user, activityTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/template/document/get-all-document-templates/${activityTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  getDocumentTemplatesOfCompany: async (user, companyId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/template/document/get-all-company-document-templates/${companyId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  saveDocumentTemplate: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/template/document/save-document-template`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },
  updateDocumentTemplate: async (user, templateId, payload) => {
    return (
      await axios.put(
        `${NODE_BASE_URL}/admin/template/document/update-document-template/${templateId}`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },
  deleteDocumentTemplate: async (user, templateId) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/admin/template/document/delete-document-template/${templateId}`,
        getAxiosOptions(user)
      )
    ).data
  },

  getProcessDataForDocPreview: async (user, activityTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/data-entry/process-data/doc-preview-process-list/${activityTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  downloadPreviewPdf: async (user, processId, templateId, pageIndex) => {
    const query = pageIndex !== null && pageIndex !== undefined ? `?page=${pageIndex}` : ''
    return (
      await axios.get(
        `${NODE_BASE_URL}/data-entry/process-data/preview-template-doc-pdf/${processId}/${templateId}${query}`,
        {
          ...getAxiosOptions(user),
          responseType: 'blob',
        }
      )
    ).data
  },
}

export default adminDocumentTemplateService
